/* eslint ember/no-new-mixins:"off" */

// Mixin for handling single or multiple checkbox elements. Basically overrides core mouse down/up elements to reorder,
// contextualize events from potentially multiple fields. Really all rallying around smarter focus handling for new form components.

import { on } from '@ember/object/evented';
import Mixin from '@ember/object/mixin';
import $ from 'jquery';
export default Mixin.create({
  mouseTarget: '.ember-checkbox',
  mouseDown: false,
  // If any child checkbox encounters a mousedown/up event, set a single variable accordingly
  setMouseEvents: on('didInsertElement', function () {
    // eslint-disable-next-line ember/no-jquery
    $(this.element).find(this.get('mouseTarget')).on({
      mousedown: () => {
        this.set('mouseDown', true);
      },
      mouseup: () => {
        this.set('mouseDown', false);
      }
    });
  }),
  removeMouseEvents: on('willDestroyElement', function () {
    // eslint-disable-next-line ember/no-jquery
    $(this.element).find(this.get('mouseTarget')).off('mousedown mouseup');
  }),
  // Key logic of the mixin. If change focus from inner checkbox A to inner checkbox B
  // we never allow isFocused to be set to false at any time. Visually it avoids any split second "flash")
  // of our of focus state; this really shouldn't happen considering we stayed "in focus" full time
  // in the master checkbox set.
  focusOut: on('focusOut', function () {
    if (this.get('mouseDown') === false) {
      this.set('isFocused', false);
    }
  })
});